import { TechemTheme } from '@techem/techem-theme';
import logoRef from 'presentation/assets/images/techemlogo_final.png';

import PhoneSupportView from 'presentation/components/PhoneSupportView';
import * as React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { styled } from 'styletron-react';
import { md } from 'presentation/theme/mediaQueries';
import { TrackerUtil } from 'tracking/TrackerUtil';
import { paths } from '../routes';

const Logo = styled('img', {
  height: '27px',
  [md]: { height: '50px' }
});

const HeaderView = styled(Col, {
  height: '80px',
  backgroundColor: TechemTheme.colors.backgroundPrimary,
  [md]: { height: '100px' }
});

const WrapperView = styled('div', {
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: TechemTheme.colors.backgroundSecondary,
  zIndex: 1000,
  backgroundColor: TechemTheme.colors.backgroundPrimary
});

const Header = () => {
  const navigate = useNavigate();

  return (
    <WrapperView id="header">
      <Container>
        <Row className="justify-content-between">
          <HeaderView xs className="d-flex">
            <Logo
              src={logoRef}
              alt="Techem Logo"
              className="d-flex mx-0 my-auto clickable-image"
              aria-label="Startseite"
              onClick={() => {
                navigate(paths.LandingPage);
                TrackerUtil.trackLinkClick('header_link_logo', 'link_logo');
              }}
            />
          </HeaderView>

          <HeaderView lg={4} md={5} sm="auto" xs="auto" className="d-flex">
            <PhoneSupportView />
          </HeaderView>
        </Row>
      </Container>
    </WrapperView>
  );
};

export default Header;
